import formFieldTypes from './formFieldTypes'

const getMaxLengthMessage = (type, maxLength) => {
  switch (type) {
    case 'text':
      return `Máximo ${maxLength} caracteres.`
    case 'number':
      return `Máximo ${maxLength} números.`
    default:
      return `Máximo ${maxLength} caracteres.`
  }
}

const getMinLengtMessage = (type, minLength) => {
  switch (type) {
    case 'text':
      return `Mínimo ${minLength} caracteres.`
    case 'number':
      return `Mínimo ${minLength} números.`
    default:
      return `Mínimo ${minLength} caracteres.`
  }
}

const getCampoDependienteMessage = (campoPrincipal, tipo) => {
  const { autocomplete, text, textarea, date, time, number } = formFieldTypes
  switch (tipo) {
    case autocomplete:
      return `Seleccione primero un valor en: "${campoPrincipal}."`
    case text:
    case textarea:
    case number:
      return `Ingrese primero un valor en: "${campoPrincipal}."`
    case date:
      return `Ingrese primero la fecha en: "${campoPrincipal}."`
    case time:
      return `Ingrese primero la hora en: "${campoPrincipal}."`
    default:
      return 'Ningún caso'
  }
}

export const formErrorMessages = {
  dependency: getCampoDependienteMessage,
  requiredMessage: (labelName) => `${labelName} requerido.`,
  mayorQue: (labelName) => `Debe ser mayor que ${labelName}.`,
  menorQue: (labelName) => `Debe ser menor que ${labelName}.`,
  maxLength: getMaxLengthMessage,
  minLength: getMinLengtMessage,
  maxStringLength: (value) => `Máximo ${value} caracteres.`,
  maxNumberLength: (value) => `Máximo ${value} números.`,
  minNumberLength: (value) => `Mínimo ${value} números.`,
  minStringLength: (value) => `Mínimo ${value} caracteres.`,
  patternErrorMessage: (value) => `El valor ingresado es inválido.`,
  emailRequired: 'Ingrese el correo.',
  passwordRequired: 'Ingrese la contraseña.'
}
